export default __webpack_public_path__ + "static/wowmakers-e88e9039b6d1a62452980af4363bb8c8.jpeg";